<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 mb-3">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.order_numbers.create_orders.about.description' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading) {
      <ziro-datatable
        [class]="'ziro-card'"
        [dataAutomation]="'create-draft-table'"
        [columns]="columns"
        [rowDataSource]="rows"
        [uniqueRowIdentifier]="'losingCarrier'"
        [showCustomAlert]="true"
        [showSelectColumn]="true"
        [setColumnWidths]="false"
        (rowSelected)="onRowSelected()"
      >
        <div
          alert-content
          [innerHtml]="'tkey;admin.order_numbers.create_orders.datatable.no_draftable_numbers' | escapeHtml"
        ></div>
      </ziro-datatable>
    }
    @if (showNoPortsAlert) {
      <div class="alert alert-danger d-flex justify-content-between" data-automation="'noPortsAlert'">
        <span>
          <i [ngClass]="ziroIcons.WARNING_TRIANGLE"></i>
          <strong data-automation="no-ports-alert-text">
            {{ 'tkey;admin.order_numbers.create_orders.no_numbers_warning.text' | translate }}
          </strong>
        </span>
      </div>
    }
    <div class="card mb-4" data-automation="site-info" [hidden]="showNoPortsAlert">
      <div class="card-header d-flex justify-content-between align-items-center bg-info text-white fs-5 p-3">
        <span class="p-0 m-0">
          <i [ngClass]="ziroIcons.SITE"></i>
          {{ 'tkey;admin.order_numbers.create_orders.create_draft.site_form.header.label' | translate }}
        </span>
      </div>
      <div class="card-body pb-0">
        <ziro-text [fieldId]="'customerOrderId'"></ziro-text>
        <ziro-date [fieldId]="'desiredFocDate'"></ziro-date>
        <ziro-text [fieldId]="'loaAuthorizingPerson'"></ziro-text>
        <ziro-text [fieldId]="'businessName'"></ziro-text>
        <ziro-text [fieldId]="'houseNumber'"></ziro-text>
        <ziro-text [fieldId]="'streetName'"></ziro-text>
        <ziro-text [fieldId]="'addressLine2'"></ziro-text>
        <ziro-text [fieldId]="'city'"></ziro-text>
        <ziro-select [fieldId]="'stateCode'"></ziro-select>
        <ziro-text [fieldId]="'country'"></ziro-text>
        <ziro-text [fieldId]="'zip'"></ziro-text>
        <ziro-text [fieldId]="'billingTelephoneNumber'"></ziro-text>
        <ziro-text [fieldId]="'accountNumber'"></ziro-text>
        <ziro-text [fieldId]="'pinNumber'"></ziro-text>
        <ziro-checkbox [fieldId]="'partialPort'"></ziro-checkbox>
        <ziro-text [fieldId]="'newBillingTelephoneNumber'"></ziro-text>
      </div>
    </div>
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
